:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;

  .category-button-content {
    display: flex;
    align-items: center;
    margin-right: -12px;

    .action-icon {
      font-size: 30px;
    }
  }
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.company-selector-action {
  display: flex;
  justify-content: end;
  padding: 4px calc(2 * var(--spacer));
  background: var(--white-layout-301-level-0-elevation);
}

.company-selector {
  width: auto;
}
